import {
  AUTOALLOCATE_WEIGHTINGS_GET_REQUEST,
  AUTOALLOCATE_WEIGHTINGS_GET_SUCCESS,
  AUTOALLOCATE_WEIGHTINGS_GET_FAILURE,
  AUTOALLOCATE_WEIGHTINGS_UPDATE_REQUEST,
  AUTOALLOCATE_WEIGHTINGS_UPDATE_SUCCESS,
  AUTOALLOCATE_WEIGHTINGS_UPDATE_FAILURE,
} from '../../constants/types';
import { HTTP_METHOD } from '../../constants/methods';
import globals from '../../../globals/communityGlobals';

const overrideApiUrl = globals.urls.autoAllocateApiUrl;

function getAutoAllocateWeightings() {
  return {
    types: [
      AUTOALLOCATE_WEIGHTINGS_GET_REQUEST,
      AUTOALLOCATE_WEIGHTINGS_GET_SUCCESS,
      AUTOALLOCATE_WEIGHTINGS_GET_FAILURE,
    ],
    buildCallParameters: () => ({
      method: HTTP_METHOD.GET,
      path: 'v1/query/GetAutoAllocateWeightings',
      overrideApiUrl,
    }),
  };
}

function updateAutoAllocateWeightings(data) {
  return {
    types: [
      AUTOALLOCATE_WEIGHTINGS_UPDATE_REQUEST,
      AUTOALLOCATE_WEIGHTINGS_UPDATE_SUCCESS,
      AUTOALLOCATE_WEIGHTINGS_UPDATE_FAILURE,
    ],
    buildCallParameters: () => ({
      method: HTTP_METHOD.POST,
      data: {
        AutoAllocateWeightings: data,
      },
      path: 'v1/command/UpdateAutoAllocateWeightings',
      overrideApiUrl,
    }),
  };
}

export { getAutoAllocateWeightings, updateAutoAllocateWeightings };
